import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@saleor/components/Checkbox";
// import Date from "@saleor/components/Date";
// import Money from "@saleor/components/Money";
// import Percent from "@saleor/components/Percent";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TableHead from "@saleor/components/TableHead";
import TablePagination from "@saleor/components/TablePagination";
// import { SaleListUrlSortField } from "@saleor/discounts/urls";
import { maybe, renderCollection, splitDateTime } from "@saleor/misc";
import { RegisterList_recommend_edges_node } from "@saleor/register/types/RegisterList";
import { RegisterListUrlSortField } from "@saleor/register/urls";
import { ListActions, ListProps, SortPage } from "@saleor/types";
// import { SaleType } from "@saleor/types/globalTypes";
import { getArrowDirection } from "@saleor/utils/sort";
import React from "react";
import { FormattedMessage } from "react-intl";

export interface RegisterListProps
  extends ListProps,
    ListActions,
    SortPage<RegisterListUrlSortField> {
  defaultCurrency: string;
  registers: RegisterList_recommend_edges_node[];
}

const useStyles = makeStyles(
  theme => ({
    [theme.breakpoints.up("lg")]: {
      colEnd: {
        width: 250
      },
      colName: {
        // width: 500
      },
      colStart: {
        width: 400
      },
      colValue: {
        width: 200
      }
    },
    colEnd: {
      textAlign: "right"
    },
    colName: {
      paddingLeft: 0
    },
    colStart: {
      textAlign: "left"
    },
    colValue: {
      textAlign: "right"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  // { name: "SaleList" }
  { name: "RegisterList" }
);

const numberOfColumns = 7;

const RegisterList: React.FC<RegisterListProps> = props => {
  const {
    settings,
    // defaultCurrency,
    disabled,
    onNextPage,
    onPreviousPage,
    onUpdateListSettings,
    onRowClick,
    onSort,
    pageInfo,
    registers,
    isChecked,
    selected,
    sort,
    toggle,
    toggleAll,
    toolbar
  } = props;

  const classes = useStyles(props);

  return (
    <ResponsiveTable>
      <TableHead
        colSpan={numberOfColumns}
        selected={selected}
        disabled={disabled}
        items={registers}
        toggleAll={toggleAll}
        toolbar={toolbar}
      >
        {/* <TableCellHeader
          className={classes.colName}
        >
          <FormattedMessage defaultMessage="registers ID" description="sale name" />
        </TableCellHeader> */}
        <TableCellHeader
          direction={
            sort.sort === RegisterListUrlSortField.fromEmail
              ? getArrowDirection(sort.asc)
              : undefined
          }
          arrowPosition="right"
          onClick={() => onSort(RegisterListUrlSortField.fromEmail)}
          className={classes.colStart}
        >
          <FormattedMessage
            defaultMessage="User Email"
            description="register fromEmail"
          />
        </TableCellHeader>
        {/* <TableCellHeader className={classes.colName}>
          <FormattedMessage
            defaultMessage="Products Count"
            description="Products Count"
          />
        </TableCellHeader> */}
        {/* <TableCellHeader className={classes.colName}>
          <FormattedMessage
            defaultMessage="SKU Count"
            description="SKU Count"
          />
        </TableCellHeader> */}
        <TableCellHeader
          direction={
            sort.sort === RegisterListUrlSortField.recommendEmail
              ? getArrowDirection(sort.asc)
              : undefined
          }
          // textAlign="right"
          onClick={() => onSort(RegisterListUrlSortField.recommendEmail)}
          className={classes.colStart}
        >
          <FormattedMessage
            defaultMessage="Friend Email"
            description="recommendEmail"
          />
        </TableCellHeader>
        <TableCellHeader
          direction={
            sort.sort === RegisterListUrlSortField.created
              ? getArrowDirection(sort.asc)
              : undefined
          }
          // textAlign="right"
          onClick={() => onSort(RegisterListUrlSortField.created)}
          className={classes.colStart}
        >
          <FormattedMessage
            defaultMessage="Friend Register Time"
            description="created"
          />
        </TableCellHeader>
        {/* <TableCellHeader
          direction={
            sort.sort === SaleListUrlSortField.value
              ? getArrowDirection(sort.asc)
              : undefined
          }
          textAlign="right"
          onClick={() => onSort(SaleListUrlSortField.value)}
          className={classes.colValue}
        >
          <FormattedMessage defaultMessage="Value" description="sale value" />
        </TableCellHeader> */}
      </TableHead>
      <TableFooter>
        <TableRow>
          <TablePagination
            colSpan={numberOfColumns}
            settings={settings}
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            onNextPage={onNextPage}
            onUpdateListSettings={onUpdateListSettings}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onPreviousPage={onPreviousPage}
          />
        </TableRow>
      </TableFooter>
      <TableBody>
        {renderCollection(
          registers,
          registers => {
            const isSelected = registers ? isChecked(registers.id) : false;

            return (
              <TableRow
                className={!!registers ? classes.tableRow : undefined}
                hover={!!registers}
                key={registers ? registers.id : "skeleton"}
                onClick={registers ? onRowClick(registers.id) : undefined}
                selected={isSelected}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isSelected}
                    disabled={disabled}
                    disableClickPropagation
                    onChange={() => toggle(registers.id)}
                  />
                </TableCell>
                {/* <div></div> */}
                <TableCell className={classes.colStart}>
                  {maybe<React.ReactNode>(
                    () => registers.fromEmail,
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.colStart}>
                  {maybe<React.ReactNode>(
                    () => registers.recommendEmail,
                    <Skeleton />
                  )}
                </TableCell>
                {/* <TableCell className={classes.colStart}>
                  {maybe<React.ReactNode>(() => registers.created, <Skeleton />)}
                </TableCell> */}
                <TableCell className={classes.colStart}>
                  {registers && registers.created ? (
                    splitDateTime(maybe(() => registers.created, "")).date +
                    " " +
                    splitDateTime(maybe(() => registers.created, "")).time
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                {/* <TableCell className={classes.colName}>
                  {maybe<React.ReactNode>((): any => {
                    const count = sale.variants.totalCount || 0;
                    return count;
                  }, <Skeleton />)}
                </TableCell> */}
                {/* <TableCell className={classes.colStart}>
                  {sale && sale.startDate ? (
                    splitDateTime(maybe(() => sale.startDate, "")).date +
                    " " +
                    splitDateTime(maybe(() => sale.startDate, "")).time
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.colEnd}>
                  {sale && sale.endDate ? (
                    splitDateTime(maybe(() => sale.endDate, "")).date +
                    " " +
                    splitDateTime(maybe(() => sale.endDate, "")).time
                  ) : sale && sale.endDate === null ? (
                    "-"
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell
                  className={classes.colValue}
                  onClick={sale ? onRowClick(sale.id) : undefined}
                >
                  {sale && sale.type && sale.value ? (
                    sale.type === SaleType.FIXED ? (
                      <Money
                        money={{
                          amount: sale.value,
                          currency: defaultCurrency
                        }}
                      />
                    ) : (
                      <Percent amount={sale.value} />
                    )
                  ) : (
                    <Skeleton />
                  )}
                </TableCell> */}
              </TableRow>
            );
          },
          () => (
            <TableRow>
              <TableCell colSpan={numberOfColumns}>
                <FormattedMessage defaultMessage="No registers found" />
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </ResponsiveTable>
  );
};
RegisterList.displayName = "RegisterList";
export default RegisterList;
